import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class RebateService {

    constructor(
        private httpService: HttpService) { }
    /**
     * 获取当前用户是否存在私返权限
     */
    getUserIsPrivateReturn() {
        const url = AppConfig.GetProdUrl() + '/LotteryPrivateReturn/GetUserIsPrivateReturn';
        return this.httpService.get(url);
    }

    /**
     * 获取当前用户的直属下级私返报表信息
     */
    getSubDividendRecordList(params) {
        const url = AppConfig.GetProdUrl() + '/LotteryPrivateReturn/GetSubDividendRecordList';
        return this.httpService.post(url, params);
    }

    /**
     * 获取私返配置信息
     */
    getPrivateRuleList(params) {
        const url = AppConfig.GetProdUrl() + '/LotteryPrivateReturn/GetPrivateRuleList';
        return this.httpService.post(url, params);
    }

    /**
     * 设定私返
     */
    setPrivateRule(params) {
        const url = AppConfig.GetProdUrl() + '/LotteryPrivateReturn/SetPrivateRule';
        return this.httpService.post(url, params);
    }

    /**
     * 发放私返
     */
    giveDividend(params) {
        const url = AppConfig.GetProdUrl() + '/LotteryPrivateReturn/GivePrivateWage';
        return this.httpService.post(url, params);
    }

    /**
     * 删除私返
     */
    deletePrivate(params) {
        const url = AppConfig.GetProdUrl() + '/LotteryPrivateReturn/DeletePrivate';
        return this.httpService.post(url, params);
    }
    /**
     * 删除私返规则
     */
    deletePrivateRule(userName) {
        let param = 'userName=' + userName;
        const url = AppConfig.GetProdUrl() + '/LotteryPrivateReturn/DeletePrivateRule?' + param;
        return this.httpService.get(url);
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/services/rebate.service.ts